import {styled, Select} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"
import {COUNTRY_SELECTOR_DRAWER_BREAKPOINT} from "../../../../config/constants"

export const StyledSelect = styled(Select)`
    width: 100%;
    height: 2.75rem;
    @media (min-width: ${COUNTRY_SELECTOR_DRAWER_BREAKPOINT}) {
        width: 28rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        height: 2rem;
    }
    && > div {
        padding: 0 2.25rem 0 1rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
    }
    && > div:focus {
        background-color: transparent;
    }
    &&.selectOpen {
        border-radius: 0.25rem 0.25rem 0 0;
    }
    && .selectBody {
        border-radius: 0 0 0.25rem 0.25rem;
    }
    && > div > .MuiMenu-paper {
        max-height: 18.75rem;
        width: 28rem;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.menu.default.borderRadius};
    }
`
